export default __webpack_public_path__ + "static/media/second.b573ebc4.svg";